<template>
  <div id="Transactions">
    <main>
      <div class="page-header pb-10 page-header-dark bg-gradient-primary-to-secondary">
        <div class="container-fluid">
          <div class="page-header-content">
            <h1 class="page-header-title">
              <div class="page-header-icon">
                <i data-feather="activity"></i>
              </div>
              <span>Transactions</span>
            </h1>
            <!--  <div class="page-header-subtitle">Support Ticketing Reports</div> -->
          </div>
        </div>
      </div>
      <div class="container-fluid mt-n10">
        <div class="row">
          <div class="col-md-12">
            <div class="card mb-4">
              <!-- <div class="card-header">DataTable Example</div> -->
              <div class="card-body">
                <vue-good-table
                  :columns="columns"
                  :rows="transactions"
                  :search-options="{
                    enabled: true,
                    trigger: 'enter',
                  }"
                  :pagination-options="{
                    enabled: true,
                    perPage: 20,
                  }"
                  styleClass="vgt-table condensed myGoodTable"
                >
                  <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'status'">{{props.row.status}}</span>
                    <span v-if="props.column.field == 'reference'">{{props.row.reference}}</span>
                    <span v-if="props.column.field == 'amount'">{{props.row.amount/100 | currency}}</span>
                    <span v-if="props.column.field == 'account'">{{props.row.client.name}}</span>
                    <span v-if="props.column.field == 'user'">{{props.row.user.name}}</span>
                    <span v-if="props.column.field == 'package'">{{props.row.package}}</span>
                    <span v-if="props.column.field == 'gateway'">{{props.row.gateway}}</span>
                    <span v-if="props.column.field == 'createdAt'">{{props.row.createdAt | formatDateTime}}</span>
                  </template>
                </vue-good-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Transactions",

  data() {
    return {
      transactions: [],
      columns: [
        {
          label: "Status",
          field: "status",
        },
        {
          label: "Reference",
          field: "reference",
        },
        {
          label: "Amount",
          field: "amount",
        },
        {
          label: "Account",
          field: "account",
        },
        {
          label: "User",
          field: "user",
        },
        {
          label: "Package",
          field: "package",
        },
        {
          label: "Gateway",
          field: "gateway",
        },
        {
          label: "Date/Time",
          field: "createdAt",
        },
      ],
    };
  },

  mounted() {
    let loading = this.$loading.show();
    axios.get("/admin/transactions").then((res) => {
      if (res.data.status == "success") {
        this.transactions = res.data.transactions;
      }
      loading.hide();
    });
  },

  methods: {},

  computed: {
    client() {
      return this.$store.state.client;
    },
  },
};
</script>